import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useModules } from '../contexts/ModuleContext'
import ProtectedRoute from './ProtectedRoute'
import LoadingHandler from './LoadingHandler'

const ModuleRoute = ({ children, moduleName }) => {
  const { isModuleEnabled } = useModules()
  const location = useLocation()

  if (!isModuleEnabled(moduleName)) {
    return (
      <Navigate
        to="/module-disabled"
        state={{
          moduleName,
          from: location.pathname,
        }}
        replace
      />
    )
  }

  return (
    <ProtectedRoute>
      <LoadingHandler>{children}</LoadingHandler>
    </ProtectedRoute>
  )
}

export default ModuleRoute
